module.exports = __webpack_public_path__ + "static/media/illustration-exposures-done.83f8fe5c.svg";